import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fa3ab306"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header d-flex justify-content-between" }
const _hoisted_2 = { class: "title m-0 pt-1 pt-md-0" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "modal_content" }
const _hoisted_5 = { class: "modal_header pb-3" }
const _hoisted_6 = { class: "pt-2 pb-2" }
const _hoisted_7 = { class: "footer float-end" }

import BsDialog from '@/components/BsDialog/BsDialog.vue'
import XCircleIcon from '@/icons/XCircleIcon.vue'
import BarButton from '@/components/BarButton'
import locales from './CoachingSessionCancelConfirmation.locales.en.json'
import { useSessionRegistryStore } from '../SessionRegistryStore'


export default /*#__PURE__*/_defineComponent({
  __name: 'CoachingSessionCancelConfirmation',
  setup(__props) {

const { sessionState } = useSessionRegistryStore()



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BsDialog, {
    "class-names": "coaching-session-cancel-confirm-dialog",
    "close-on-escape": "",
    "close-on-backdrop-click": "",
    "mobile-floating": ""
  }, {
    header: _withCtx(({ close }) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h5", _hoisted_2, _toDisplayString(!_unref(sessionState).isLSAT ? _unref(locales).title_session_cancel_confirmed : _unref(locales).title_session_cancel_confirmed_LSAT), 1),
        _createElementVNode("button", {
          class: "button",
          onClick: close
        }, [
          _createVNode(XCircleIcon)
        ], 8, _hoisted_3)
      ])
    ]),
    footer: _withCtx(({ close }) => [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_unref(BarButton), {
          class: "footer-button me-0 me-md-2",
          onClick: close
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(locales).back_to_sessions), 1)
          ]),
          _: 2
        }, 1032, ["onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(!_unref(sessionState).isLSAT ? _unref(locales).cancel_confirmed : _unref(locales).cancel_confirmed_LSAT), 1)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})